<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.CLIENT_DATA'
              | translate
          }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let activityDescriptionFormControlAlertShouldBeVisible =
      submitted && !isActivityDescriptionFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          activityDescriptionFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.ActivityDescription">
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.ACTIVITY_DESCRIPTION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ActivityDescription"
                [id]="controlName.ActivityDescription"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ActivityDescription"
              ></textarea>
            </div>
          </div>
        </div>

        @if (activityDescriptionFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let installationOperatingTimeFormControlAlertShouldBeVisible =
      submitted && !isInstallationOperatingTimeFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          installationOperatingTimeFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.InstallationOperatingTime"
          >
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.INSTALLATION_OPERATING_TIME'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <input
                type="text"
                [name]="controlName.InstallationOperatingTime"
                [id]="controlName.InstallationOperatingTime"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.InstallationOperatingTime"
              />
            </div>
          </div>
        </div>

        @if (installationOperatingTimeFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let emissionTypeAndAmountFormControlAlertShouldBeVisible =
      submitted && !isEmissionTypeAndAmountFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          emissionTypeAndAmountFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.EmissionTypeAndAmount">
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.EMISSION_TYPE_AND_AMOUNT'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.EmissionTypeAndAmount"
                [id]="controlName.EmissionTypeAndAmount"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.EmissionTypeAndAmount"
              ></textarea>
            </div>
          </div>
        </div>

        @if (emissionTypeAndAmountFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let emissionReductionMethodsFormControlAlertShouldBeVisible =
      submitted && !isEmissionReductionMethodsFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          emissionReductionMethodsFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label class="mb-0" [attr.for]="controlName.EmissionReductionMethods">
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.EMISSION_REDUCTION_METHODS'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.EmissionReductionMethods"
                [id]="controlName.EmissionReductionMethods"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.EmissionReductionMethods"
              ></textarea>
            </div>
          </div>
        </div>

        @if (emissionReductionMethodsFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    @let reductionCompliantDescriptionFormControlAlertShouldBeVisible =
      submitted && !isReductionCompliantDescriptionFormControlValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          reductionCompliantDescriptionFormControlAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.ReductionCompliantDescription"
          >
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.REDUCTION_COMPLIANT_DESCRIPTION'
                | translate
            }}
          </label>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <textarea
                [name]="controlName.ReductionCompliantDescription"
                [id]="controlName.ReductionCompliantDescription"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.ReductionCompliantDescription"
              ></textarea>
            </div>
          </div>
        </div>

        @if (reductionCompliantDescriptionFormControlAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELD_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <section>
      <div class="card card-border-color-from-db mb-4">
        <div class="card-header card-header-color-from-db">
          <label
            class="mb-0"
            [attr.for]="controlName.IsCombustionSourceRequired"
          >
            {{
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE_HEADER'
                | translate
            }}
          </label>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <mat-checkbox
                [id]="controlName.IsCombustionSourceRequired"
                [formControlName]="controlName.IsCombustionSourceRequired"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE_CONDITIONS'
                    | translate
                }}
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p
            class="text-muted m-0"
            [innerHTML]="
              'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE_CONDITIONS_DESCRIPTION'
                | translate
            "
          ></p>
        </div>
      </div>
    </section>

    @let combustionSourceFormGroup = getCombustionSourceFormGroup();
    @if (combustionSourceFormGroup) {
      <ng-container [formGroup]="combustionSourceFormGroup">
        @let businessActivityCodeFormControlAlertShouldBeVisible =
          submitted && !isBusinessActivityCodeFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              businessActivityCodeFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.BusinessActivityCode"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.BUSINESS_ACTIVITY_CODE'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [id]="combustionSourceControlName.BusinessActivityCode"
                    [attr.name]="
                      combustionSourceControlName.BusinessActivityCode
                    "
                    [formControlName]="
                      combustionSourceControlName.BusinessActivityCode
                    "
                  ></textarea>
                </div>
              </div>
            </div>
            @if (businessActivityCodeFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let shouldShowRegonRequiredAlertResult =
          submitted && shouldShowRequiredAlert(getRegonFormControl());
        @let shouldShowRegonAlertResult = shouldShowRegonAlert();
        @let regonFormControlAlertShouldBeVisible =
          shouldShowRegonRequiredAlertResult || shouldShowRegonAlertResult;
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              regonFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.Regon"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.REGON'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <input
                    class="form-control form-control-sm required"
                    [id]="combustionSourceControlName.Regon"
                    [attr.name]="combustionSourceControlName.Regon"
                    [formControlName]="combustionSourceControlName.Regon"
                    type="string"
                    (keypress)="validateIntegerInput($event)"
                  />
                </div>
              </div>
            </div>
            @if (regonFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                @if (shouldShowRegonRequiredAlertResult) {
                  <div class="alert alert-danger my-2">
                    {{ 'FIELD_REQUIRED' | translate }}
                  </div>
                }
                @if (shouldShowRegonAlertResult) {
                  <div class="alert alert-danger my-2">
                    {{ 'LEGAL_PERSON_FORM.PRINCIPAL.REGON_ERROR' | translate }}
                  </div>
                }
              </div>
            }
          </div>
        </section>

        @let combustionPowerFormControlAlertShouldBeVisible =
          submitted && !isCombustionPowerFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              combustionPowerFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.CombustionPower"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.COMBUSTION_POWER'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="input-group input-group-sm">
                    <input
                      type="number"
                      class="form-control required"
                      aria-required="true"
                      [id]="combustionSourceControlName.CombustionPower"
                      [attr.name]="combustionSourceControlName.CombustionPower"
                      [formControlName]="
                        combustionSourceControlName.CombustionPower
                      "
                      (keypress)="validateFloatInput($event)"
                    />
                    <span class="input-group-text">MW</span>
                  </div>
                </div>
              </div>
            </div>
            @if (combustionPowerFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let combustionSourceTypeFormControlAlertShouldBeVisible =
          submitted && !isCombustionSourceTypeFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              combustionSourceTypeFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.CombustionSourceType"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.COMBUSTION_SOURCE_TYPE'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [id]="combustionSourceControlName.CombustionSourceType"
                    [attr.name]="
                      combustionSourceControlName.CombustionSourceType
                    "
                    [formControlName]="
                      combustionSourceControlName.CombustionSourceType
                    "
                  ></textarea>
                </div>
              </div>
            </div>
            @if (combustionSourceTypeFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let fuelShareTypeFormControlAlertShouldBeVisible =
          submitted && !isFuelShareTypeFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              fuelShareTypeFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.FuelShareType"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.FUEL_SHARE_TYPE'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [id]="combustionSourceControlName.FuelShareType"
                    [attr.name]="combustionSourceControlName.FuelShareType"
                    [formControlName]="
                      combustionSourceControlName.FuelShareType
                    "
                  ></textarea>
                </div>
              </div>
            </div>
            @if (fuelShareTypeFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let emissionStandardsFormControlAlertShouldBeVisible =
          submitted && !isEmissionStandardsFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              emissionStandardsFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.EmissionStandards"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.EMISSION_STANDARDS'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [id]="combustionSourceControlName.EmissionStandards"
                    [attr.name]="combustionSourceControlName.EmissionStandards"
                    [formControlName]="
                      combustionSourceControlName.EmissionStandards
                    "
                  ></textarea>
                </div>
              </div>
            </div>
            @if (emissionStandardsFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let commissionDateFormControlAlertShouldBeVisible =
          submitted && isCommissionDateFormControlInvalid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              commissionDateFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.CommissionDate"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.COMMISSION_DATE'
                    | translate
                }}
              </label>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <mat-checkbox
                    #comissionDateUnknownCheckbox
                    [id]="combustionSourceControlName.CommissionDateUnknown"
                    [formControlName]="
                      combustionSourceControlName.CommissionDateUnknown
                    "
                  >
                    {{
                      'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.COMMISION_DATE_UNKNOWN'
                        | translate
                    }}
                  </mat-checkbox>
                </div>
              </div>
              @if (comissionDateUnknownCheckbox.checked) {
                <div class="row mt-2 mb-3">
                  <div class="col-12">
                    <div class="alert alert-info m-0" role="alert">
                      {{
                        'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.COMMISION_DATE_PROOF'
                          | translate
                      }}
                    </div>
                  </div>
                </div>
              }
              <div class="input-group mt-2">
                <input
                  #commissionDateInput
                  class="form-control form-control-sm required"
                  [attr.placeholder]="
                    'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                  "
                  [id]="combustionSourceControlName.CommissionDate"
                  [name]="combustionSourceControlName.CommissionDate"
                  [formControlName]="combustionSourceControlName.CommissionDate"
                  ngbDatepicker
                  #commissionDateFromDatePicker="ngbDatepicker"
                />
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="commissionDateFromDatePicker.toggle()"
                  [disabled]="commissionDateInput.disabled"
                  type="button"
                ></button>
              </div>
            </div>

            @if (commissionDateFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>

        @let loadTimeDescriptionFormControlAlertShouldBeVisible =
          submitted && !isLoadTimeDescriptionFormControlValid();
        <section>
          <div
            class="card mb-4"
            [ngClass]="
              loadTimeDescriptionFormControlAlertShouldBeVisible
                ? 'border-danger border-2'
                : 'card-border-color-from-db'
            "
          >
            <div class="card-header card-header-color-from-db">
              <label
                class="mb-0"
                [attr.for]="combustionSourceControlName.LoadTimeDescription"
              >
                {{
                  'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.COMBUSTION_SOURCE.LOAD_TIME_DESCRIPTION'
                    | translate
                }}
              </label>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea
                    class="form-control form-control-sm required"
                    aria-required="true"
                    [id]="combustionSourceControlName.LoadTimeDescription"
                    [attr.name]="
                      combustionSourceControlName.LoadTimeDescription
                    "
                    [formControlName]="
                      combustionSourceControlName.LoadTimeDescription
                    "
                  ></textarea>
                </div>
              </div>
            </div>
            @if (loadTimeDescriptionFormControlAlertShouldBeVisible) {
              <div class="card-footer">
                <div class="alert alert-danger my-2">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              </div>
            }
          </div>
        </section>
      </ng-container>
    }

    <section>
      @let landParcelsChosen = areLandParcelsChosen();
      <div
        class="card mb-4"
        [ngClass]="
          submitted && !landParcelsChosen
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{
            'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.MAP_LOCATION'
              | translate
          }}
        </div>

        <div class="card-body">
          <gk-map
            [mapState]="mapState"
            (dispatch)="handleMapAction($event)"
          ></gk-map>

          <div class="my-2">
            @if (mapState.mapObjectTablesState[0].mapObjects.length) {
              <gk-map-object-table
                [mapState]="mapState"
                [mapObjectTableStateIndex]="0"
                (dispatch)="handleMapAction($event)"
              ></gk-map-object-table>
            }
          </div>
        </div>
        @if (submitted && !landParcelsChosen) {
          <div class="card-footer">
            <div class="alert alert-danger mt-2">
              {{
                'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.LAND_PARCEL_REQUIRED'
                  | translate
              }}
            </div>
          </div>
        }
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredOtherFile]="otherFileRequired"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
        [buttonClass]="'btn-color-from-db'"
      ></app-cautions>
    </section>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{
          'INSTALLATION_NOTIFICATION_WITHOUT_EMISSION_PERMIT.SUBMIT' | translate
        }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/zgloszenieInstalacjiEmisyjnejBezWymoguZezwolenia/podglad'
        "
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
